var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_box"},[_c('van-loading',{attrs:{"type":"spinner","color":"rgb(242, 19, 19)","vertical":"","size":"30px"}},[_vm._v("数据加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }